import { usePage } from '@inertiajs/react';
import {
  Box,
  Button,
  Checkbox,
  Container,
  Grid,
  GridCol,
  Group,
  Image,
  rem,
  Stack,
  Text,
  TextInput,
  Title,
  useMantineTheme,
} from '@mantine/core';
import { isEmail } from '@mantine/form';
import { useDisclosure, useMediaQuery } from '@mantine/hooks';
import { IconArrowRight } from '@tabler/icons-react';

import { ButtonNavy } from '@/components/ButtonNavy.jsx';
import { FormProvider } from '@/components/form-context.js';
import useInertiaForm from '@/components/useInertiaForm.jsx';

import PaperPlane from './PaperPlane.png';

export default function Newsletter({ props }) {
  const pageProps = usePage().props;

  const theme = useMantineTheme();
  const isMd = useMediaQuery(`(max-width: ${theme.breakpoints.md})`);
  const isSm = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

  const [visible, handlers] = useDisclosure(false);

  const form = useInertiaForm(
    {
      initialValues: {
        email: '',
        // terms: '',
      },
      validate: {
        email: isEmail('Hatalı e-posta'),
        // terms: value => (value ? null : 'Bu alan zorunludur'),
      },
    },
    pageProps?.errors,
    route('site.newsletter'),
    'Doğrulama maili gönderildi! Lütfen adresinizi doğrulayın.',
    false,
    {
      preserveState: true,
      successCallback: () => {
        form.reset();
      },
    },
  );

  return (
    <Box py={60} bg="#F8F8FF" {...props}>
      <Container size="xl">
        <FormProvider form={form}>
          <form onSubmit={e => e.preventDefault()}>
            <Grid align="center" gutter="lg">
              <GridCol span={{ base: 12, md: '0', lg: 'auto' }}>
                <Group justify={isMd ? 'center' : 'flex-start'}>
                  <Image src={PaperPlane} mah={100} />
                </Group>
              </GridCol>
              <GridCol span={{ base: 12, md: 6 }}>
                <Stack gap={5} align={isMd ? 'center' : 'flex-start'} ta={isMd ? 'center' : 'left'}>
                  <Text fw={'bold'} fz={rem(32)} c="black" lh={1.2}>
                    Bültene Abone Olun
                  </Text>
                  <Text fz={rem(18)} lh={1.4}>
                    En son haberleri, ilgi çekici teklifleri ve emlakları alın.
                  </Text>
                </Stack>
              </GridCol>
              <GridCol span={{ base: 12, md: 'auto' }} style={{ flexGrow: 1 }}>
                <Group justify={isMd ? 'center' : 'center'} w="100%">
                  <Box w={isMd ? '100%' : 'auto'}>
                    {isMd ? (
                      <Stack w="100%">
                        <TextInput
                          placeholder="E-posta Adresinizi Yazın"
                          size="md"
                          w="100%"
                          radius="md"
                          {...form.getInputProps('email')}
                        />
                        <ButtonNavy
                          size="md"
                          radius="md"
                          fullWidth
                          rightSection={<IconArrowRight size={16} />}
                          onClick={form.handleSubmit}
                        >
                          Gönder
                        </ButtonNavy>
                      </Stack>
                    ) : (
                      <Group wrap="nowrap">
                        <TextInput
                          placeholder="E-posta Adresinizi Yazın"
                          size="md"
                          w={250}
                          radius="md"
                          {...form.getInputProps('email')}
                        />
                        <Button
                          color="navy.9"
                          size="md"
                          radius="md"
                          rightSection={<IconArrowRight size={16} />}
                          onClick={form.handleSubmit}
                        >
                          Gönder
                        </Button>
                      </Group>
                    )}
                  </Box>
                </Group>
              </GridCol>
            </Grid>
          </form>
        </FormProvider>
      </Container>
    </Box>
  );
}
